 <app-header *ngIf="showHead"></app-header>

<div class="content" role="main">
  <br>
  <div class="container-fluid main">    
    <router-outlet></router-outlet>
  </div>
</div>




